import { makeAutoObservable } from 'mobx';

class ShippingStore {
  initialShippingDetails = {
    specialInstructions: "",
    firstName: "",
    lastName: "",
    phoneNo: "",
    shippingAddress: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    shippingMethod: "",
  };

  shippingDetails = { ...this.initialShippingDetails };

  constructor() {
    makeAutoObservable(this);
    const savedShippingDetails = localStorage.getItem("shippingDetails");
    if (savedShippingDetails) {
      this.shippingDetails = JSON.parse(savedShippingDetails);
    }
  }

  updateField(details: any) {
    this.shippingDetails = {
      ...this.shippingDetails,
      ...details.shippingDetails,
      specialInstructions: details.specialInstructions,
    };
    localStorage.setItem("shippingDetails", JSON.stringify(this.shippingDetails));
    console.log(this.shippingDetails);
  }

  getShippingDetails() {
    return this.shippingDetails;
  }

  clearShippingDetails() {
    this.shippingDetails = { ...this.initialShippingDetails };
    localStorage.removeItem("shippingDetails");
    console.log("Shipping details cleared:", this.shippingDetails);
  }
}

const shippingStore = new ShippingStore();
export default shippingStore;
